import { Component, Input } from '@angular/core';
import { FiltersChannel } from '../../../models/filters-channel.model';

@Component({
  standalone: false,
  selector: 'suvo-bi-channel-debug-label',
  templateUrl: './channel-debug-label.component.html',
  styleUrls: ['./channel-debug-label.component.scss'],
})
export class ChannelDebugLabelComponent {
  @Input() filtersChannel: FiltersChannel;
}
